'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { PolicyDetailScreen } from '../-components/PolicyDetailScreen';
export const Route = createFileRoute('/_staff/settings/notification-and-response/notification-policies/$policyId/')({
  component: NotificationPolicyDetail
});
function NotificationPolicyDetail() {
  const {
    policyId
  } = Route.useParams();
  return <PolicyDetailScreen policyId={policyId} />;
}